import React from 'react';
import {Trans} from '@lingui/react';

import {AppUrls} from 'shared/config/model/urls';
import {isTranslate} from 'shared/lib/lang';

import LinkButton from '../LinkButton/LinkButton';

import styles from './UpgradeTariffButton.module.scss';

const UpgradeTariffButton: React.FC = () => {

    return (
        <LinkButton
            href={isTranslate() ? AppUrls.PRICING : AppUrls.TARIFFS}
            primary
            block
            className={styles.button}
        >
            <Trans id="batch.result.upgrade.link" message="Улучшить тарифный план"/>
        </LinkButton>
    );
};

export default UpgradeTariffButton;